import { render, staticRenderFns } from "./ProjectManagementCard.vue?vue&type=template&id=54677490&"
import script from "./ProjectManagementCard.vue?vue&type=script&lang=js&"
export * from "./ProjectManagementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports